const Contants = {
  MESSAGE: {
    LoginSuccess: "Login successfully!",
    RequiredUserInfo: "Please input user info!",
    UserNotExist: "User does not exist!",
    LoginInfoIncorrect: "Login information is incorrect",
    LogoutSuccess: "Logout successfully!",
    NotAuthorization: "You don't have authorization!",
    WannaLogout: "Do you really want to logout?",
    UpdateSuccess: "Update successfully!",
    UpdateError: "Update error!",
    InvalidData: "Invalid data. Please check the input!",
    WrongPassword: "Wrong password!",
    PasswordSuccess:
      "Change password successfully. Please login with your new password!",
  },
  RESPONSE_TYPES: {
    Success: "Success",
    Error: "Error",
    Warning: "Warning",
  },
  STATUS: {
    Active: 1,
    InActive: 2,
  },
  STATUS_TEXT: {
    1: "Active",
    2: "Inactive",
  },
  MATERIAL_TYPES: {
    CUSHIONS: "FABRIC",
    "ARM TYPE": "ARM FINISH",
    "TABLE TOP": "FSC TABLE TOP",
    UPHOLSTERY: "SEAT",
    LEGS: "LEG FINISH",
    "SIDE PANELS": "SIDE PANEL",
  },
  CART_STATUS: {
    Unsaved: 1,
    Saved: 2,
  },
  CART_STATUS_TEXT: {
    1: "Unsaved",
    2: "Saved",
  },
  USER_TYPES: {
    Internal: 1,
    External: 2,
    Guest: 3,
  }
};
Contants.install = function(Vue) {
  Vue.prototype.$const = Contants;
};
export default Contants;



// WEBPACK FOOTER //
// ./src/util/constant.js